<template>
    <div class="d-flex flex-column">
        <div class="d-flex justify-content-between">
            <div class="time-slot"></div>
            <div v-for="(day, index) in days" class="week-header flex-1">
                <div class="text-center font-weight-bold d-md-none">{{getNameOfDay(index, true)}}</div>
                <div class="text-center font-weight-bold d-none d-md-block">{{getNameOfDay(index)}}</div>
                <div class="text-center d-none d-md-block">{{getFormattedDate(day)}}</div>
            </div>
        </div>
        <template  v-for="hour in hoursArray">
            <div class="d-flex justify-content-between week-row">
                <div class="time-slot week-hour-start">{{('0' + hour).slice(-2)}}</div>
                <div v-for="(day, index) in days" class="week-slot flex-1">
                    <div v-for="schedule in getSchedulesForSlot(index, day, hour, true)"
                         class="week-schedule small"
                         :class="schedule.booking ? 'week-schedule-booked' : 'week-schedule-free'"
                         :style="getStyle(schedule, day, hour, true)">
                            <span>{{getTime(schedule.start)}}</span>
                            <span class="d-none d-md-inline">-</span>
                            <span>{{getTime(schedule.end)}}</span>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between week-row">
                <div class="time-slot"></div>
                <div v-for="(day, index) in days" class="week-slot flex-1">
                    <div v-for="schedule in getSchedulesForSlot(index, day, hour, false)"
                         class="week-schedule small"
                         :class="schedule.booking ? 'week-schedule-booked' : 'week-schedule-free'"
                         :style="getStyle(schedule, day, hour, false)">
                        <span>{{getTime(schedule.start)}}</span>
                        <span class="d-none d-md-inline">-</span>
                        <span>{{getTime(schedule.end)}}</span>
                    </div>
                </div>
            </div>

        </template>

    </div>
</template>

<script>
    let DaysEnum = Object.freeze({
        0: "Måndag",
        1: "Tisdag",
        2: "Onsdag",
        3: "Torsdag",
        4: "Fredag",
        5: "Lördag",
        6: "Söndag",
    });

    export default {
        props: ['date', 'route_weekly', 'locks'],
        name: "therapist-dash-weekly-schedule",
        data: function () {
            return {
                schedules: [],
                days: [],
                earliestStart: 0,
                latestEnd: 1440,
                hourHeightInPixels: 100, // If you change this, make sure to change the gradient
                // in frameworks.scss, .therapist-weekly-schedule-body
                schedulesInLoadedWeek: false,
                selectedYear: 0,
                selectedWeek: 0,
            }
        },
        watch: {
            date: function (newVal) {
                let newDate = new Date(newVal);
                let newYear = newDate.getFullYear();
                let newWeek = newDate.getWeekNumber();

                if (!(this.selectedYear == newYear && this.selectedWeek == newWeek)) {
                    this.fetchWeeklySchedule();

                    this.selectedYear = newYear;
                    this.selectedWeek = newWeek;
                }
            }
        },
        computed: {
            hoursArray() {
                let hoursArray = [];
                for (var i = this.startHour; i < this.endHour; i++) {
                    hoursArray.push(i);
                }
                return hoursArray;
            },
            hasLoadedSchedules: function () {
                return this.schedules.length > 0;
            },
            startHour: function () {
                return Math.floor(this.earliestStart / 60);
            },
            endHour: function () {
                return Math.ceil(this.latestEnd / 60);
            }
        },
        mounted: function () {
            this.fetchWeeklySchedule();
        },
        methods: {
            getTime(date){
                return moment(date).format('HH:mm');
            },
            getStyle(schedule, day, hour, fullHour = true) {
                let slotStart = null;
                let formattedHour = ('0' + hour).slice(-2);
                let start = moment(schedule.start);
                let end = moment(schedule.end);

                if(fullHour){
                    slotStart = moment(day + ' ' + formattedHour + ':00');
                } else {
                    slotStart = moment(day + ' ' + formattedHour + ':30');
                }

                let margin = start.diff(slotStart, "minutes");
                let height = end.diff(slotStart, "minutes") - margin;

                return 'margin-top: ' + margin + 'px;' + 'height: '+ height + 'px;'
            },
            getSchedulesForSlot(index, day, hour, fullHour = true){
                let slotStart = null;
                let slotEnd = null;
                if(fullHour){
                    let formattedHour = ('0' + hour).slice(-2);
                    slotStart = moment(day + ' ' + formattedHour + ':00');
                    slotEnd = moment(day + ' ' + formattedHour + ':30');
                } else {
                    let formattedHour = ('0' + hour).slice(-2);
                    let formattedHourEnd = ('0' + (hour+1)).slice(-2);
                    slotStart = moment(day + ' ' + formattedHour + ':30');
                    slotEnd = moment(day + ' ' + formattedHourEnd + ':00');
                }

                return _.filter(this.schedules[index], (schedule) => {
                    let startTime = moment(schedule.start);
                    return startTime.diff(slotStart) >= 0 && startTime.diff(slotEnd) < 0;
                });
            },
            getFormattedDate(date){
                return moment(date).format('MMM DD');
            },
            getNameOfDay: function (dayNumber, short = false) {
                if(short) {
                    return DaysEnum[dayNumber].substr(0,3);
                }
                return DaysEnum[dayNumber];
            },
            fetchWeeklySchedule: function () {
                let tempdate = this.date.getYMD();
                let self = this;
                axios.get(this.$portalUrl(self.route_weekly), {
                    params: {
                        date: tempdate,
                    }
                })
                    .then(function (response) {
                        if (response.data.scheduleArray) {
                            let earliestStart = 1440;
                            let latestEnd = 0;
                            let anyDayHasSchedules = false;
                            response.data.scheduleArray.forEach(function (day) {
                                if (day.length > 0) {
                                    anyDayHasSchedules = true;
                                    let earliestAsDate = new Date(day[0].start);
                                    let earliestAsMins = earliestAsDate.getMinutes() + earliestAsDate.getHours() * 60;
                                    if (earliestAsMins < earliestStart) {
                                        earliestStart = earliestAsMins;
                                    }
                                    let latestAsDate = new Date(day[day.length - 1].end);
                                    let latestAsMins = latestAsDate.getMinutes() + latestAsDate.getHours() * 60;
                                    if (latestAsMins > latestEnd) {
                                        latestEnd = latestAsMins;
                                    }
                                }
                            });
                            if (anyDayHasSchedules) {
                                self.earliestStart = earliestStart;
                                self.latestEnd = latestEnd;
                                self.schedulesInLoadedWeek = true;
                            } else {
                                self.schedulesInLoadedWeek = false;
                            }
                            self.schedules = response.data.scheduleArray;
                        } else {
                        }
                        self.days = response.data.daysArray;
                    })
                    .catch(function (error) {
                    });
            },
        },
    }

</script>

<style scoped>
    .time-slot {
        width: 20px;
        border-right: 1px solid #acaeaf;
    }

    .week-header {
        border-right: 1px solid #acaeaf;
    }

    .week-hour-start {
        border-top: 1px solid #d8dadb;
    }

    .week-row {
        height: 30px;
    }
    .week-slot {
        border-top: 1px solid #d8dadb;
        border-right: 1px solid #acaeaf;
    }

    .week-schedule {
        position: relative;
        display: block;
        background-color: #eeeeee;
        border-top: 1px solid #c9c9c9;
        border-bottom: 1px solid #c9c9c9;
        overflow: hidden;
        padding-left: 2px;
    }
    .week-schedule-free {
        border-left: 4px solid #FF4B33;
    }

    .week-schedule-booked {
        border-left: 4px solid #28C852;
    }
</style>
